const PageRoutes = {
  CHAPTER_ONE: "/",
  CHAPTER_TWO: "/chapter-two",
  IMPORTANT_CONCEPTS: "/important-concepts",
  COMMODITY: "/commodity/:id",
  COMMODITY_ROOT: "/commodity/",
};

export default PageRoutes;
